import React from 'react';
import CustomImage from '../../../components/custom-image';
import SectionTitle from '../../../components/section-title';
import ContentSlider from '../../../components/content-slider';
import CommunityBeneficiaries from '../../../content/managing-our-business-sustainability/community-beneficiaries';
import CarbonFfootprint from '../../../content/managing-our-business-sustainability/carbon-footprint';
import EnergyConserved from '../../../content/managing-our-business-sustainability/energy-conserved';
import Ltifr from '../../../content/managing-our-business-sustainability/ltifr';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const BusinessSustainability = () => {
  const slider = {
    slides: [<CommunityBeneficiaries />, <CarbonFfootprint />, <EnergyConserved />, <Ltifr />],
  };

  const breakpoint = [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '80px',
        dots: true,
        arrows: false,
      },
    },
  ];
  return (
    <div className="business-sustainability">
      <div className="container-1440">
        <ScrollPositionAnimation targetElement1="anim-1" targetElement2="anim-2">
          <div className="container">
            <div className="container-inner">
              <div className="content-row pdb-110">
                <div className="column-50">
                  <div className="left-content">
                    <div className="left-to-right anim-1">
                      <div className="desktop-img">
                        <CustomImage
                          className="custom-image"
                          imageName="sustainability-esg.jpg"
                          alt="Sustainability esg icon"
                          maxWidth="1080"
                        />
                      </div>
                      <div className="mobile-img">
                        <CustomImage
                          className="custom-image"
                          imageName="sustainability-esg-mobile.png"
                          alt="Sustainability esg icon"
                          maxWidth="1080"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column-50">
                  <div className="right-content">
                    <div className="bottom-to-top anim-2">
                      <SectionTitle
                        label="SUSTAINABILITY AND ESG"
                        lighttext="MANAGING OUR"
                        boldtext="BUSINESS SUSTAINABILITY"
                        iconimage="business-sustainability.png"
                        alt="Sustainability esg"
                      />
                      <div className="description">
                        <p>
                          Our sustainability strategy is driven by the need to address the expectations of our
                          stakeholders through mutual dialogue and need-based intervention, while at the same time
                          addressing the priorities of business performance. As a large Company creating measurable
                          economic and other impacts, we are mindful of our commitments to society, our people and our
                          environment. We are also well attuned to global expectations and standards regarding
                          sustainability, such as the United Nations Sustainable Development Goals (UN SDGs).
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="key-statice-slider">
                <h3>KEY STATISTICS</h3>
                <div className="key-statics-contetn">
                  <ContentSlider
                    data={slider.slides}
                    slidesToShow={4}
                    slidesToScroll={4}
                    customClass="blue-dots-slider"
                    responsive={breakpoint}
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollPositionAnimation>
      </div>
    </div>
  );
};

export default BusinessSustainability;
